<template>
    <div class="finance_analytics" v-can="'finance_analytic_access.access'" v-if="isMounted" :class="{isLoad: isLoad}">
        <ds-filter
            ssr
            isFooterFull
            :fields="filterFields"
            :data="filters"
            :loaded="isLoad"
            @submit="submitFilter"
            @resetFilter="refreshFilter"
        >
            <template v-slot:default>
                <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                    <div class="m-2">
                        <div class="flex w-full items-center">
                            <div class="w-full">
                                <label class="text-sm opacity-75">{{ $t('global.Send_date') }}</label>
                                <date-picker class="w-full" @select="selectDate"
                                             :date="system.date.send_date" direction="send_date"/>
                            </div>
                        </div>
                    </div>
                </vs-col>

                <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                    <div class="m-2">
                        <div class="flex w-full items-center">
                            <div class="w-full">
                                <label class="text-sm opacity-75">{{ $t('global.Deposit_date') }}</label>
                                <date-picker class="w-full" @select="selectDate"
                                             :date="system.date.first_action_date" direction="first_action_date"/>
                            </div>
                        </div>
                    </div>
                </vs-col>
            </template>

            <template v-slot:footer>
                <div class="flex items-center">
                    <vs-dropdown
                        ref="dropdown"
                        class="cursor-pointer mr-2"
                        vs-custom-content
                        vs-trigger-click
                    >
                        <a class="flex items-center cursor-pointer" href.prevent>
                            <feather-icon class="mr-1" icon="SlidersIcon" svgClasses="h-4 w-4 ml-1"/>
                            <span>{{ $t('global.view') }}</span>
                        </a>

                        <vs-dropdown-menu>
                            <ul>
                                <li class="flex items-center" v-for="(h, i) of heads" :key="i">
                                    <vs-button
                                        radius
                                        color="primary"
                                        type="flat"
                                        icon-pack="feather"
                                        @click="changeDisplay(h)"
                                        :icon="h.display ? 'icon-eye' : 'icon-eye-off'"
                                        v-bind="$iconData(h.display ? 'icon-eye' : 'icon-eye-off', h.display ? 'fi-rr-eye' : 'fi-rr-eye-crossed')"
                                    ></vs-button>
                                    <span class="ml-2 mr-4 whitespace-no-wrap">{{ $t(h.name) }}</span>
                                </li>
                            </ul>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <vs-button
                        v-can="'finance_analytic_access.download_csv'"
                        :disabled="!Object.keys(analytics).length"
                        @click="downloadCSV"
                        v-tooltip="$t('tooltip.Download_CSV')"
                        radius
                        type="flat"
                        v-bind="$iconData('icon-download', 'fi-rr-download')"
                    ></vs-button>
                </div>
            </template>
        </ds-filter>

        <ds-table
            ref="table"
            :data="analytics"
            :heads="heads"
            :view-items="[100, 250, 500]"
            :total="totalNum"
            :max-items="limitNum"
            :page="pageNum"
            :group-by="['affiliate_name', 'model', 'geo', 'country']"
            spacer
            @page="page"
            @limit="limit"
            @sort="sort"
        >
            <template #tbody>
                <tr>
                    <template v-for="(head, headIndex) of heads">
                        <td class="td"
                            v-for="(total, ind) of totals"
                            :key="`${ind + headIndex}-total`"
                        >
                            <div class="whitespace-no-wrap flex pt-4 pb-4 pl-2 pr-2">
                                <template v-if="head.value === 'invalid'">
                                    <span :class="{'invalid' : ~~total.invalid_percent >= 3}">{{ total.invalid }} / {{total.invalid_percent}}%</span>
                                </template>

                                <template v-else-if="head.value === 'ftd'">
                                    <span>{{ total.ftd }} / {{total.ftd_percent}}%</span>
                                </template>

                                <template v-else-if="head.value === 'guarantee_percent'">
                                    <span v-if="total.guarantee_percent">{{total.guarantee_percent}}%</span>
                                </template>

                                <template v-else>
                                    {{ total[head.value] }}
                                </template>
                            </div>
                        </td>
                    </template>
                </tr>
            </template>

            <template #invalid="{invalid}">
                <span :class="{'invalid' : ~~invalid.invalid_percent >= 3}">
                    {{ invalid.invalid }} / {{invalid.invalid_percent}}%
                </span>
            </template>

            <template #ftd="{ftd}">
                <span>{{ ftd.ftd }} / {{ftd.ftd_percent}}%</span>
            </template>

            <template #external_price="{external_price}">
                <div>{{ external_price.external_price }}</div>
            </template>

            <template #guarantee_percent="{guarantee_percent}">
                <div v-if="!!guarantee_percent.guarantee_percent">{{ guarantee_percent.guarantee_percent }}%</div>
                <div v-else>-</div>
            </template>
        </ds-table>
    </div>
</template>

<script>
import Table from './Table'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import vSelect from 'vue-select'
import Trn from './Trn'
import {download} from '@/utils/utils'
import {checkPermission, utils} from '@/utils/mixins'

export default {
    mixins: [checkPermission, utils],
    data() {
        return {
            isMounted: false,
            isLoad: true,
            filterFields: {},
            filters: {},
            filterSelect: {},
            system: {
                selectedDate: 'send_date',
                date: {
                    send_date: {
                        startDate: new Date(),
                        endDate: new Date()
                    },
                    first_action_date: {
                        startDate: new Date(),
                        endDate: new Date()
                    }
                },
                filterSelect: {}
            },
            is_date: 'created_at',
            isTotal: true,
            pageNum: 1,
            totalNum: 0,
            limitNum: 100,
            filterList: {},
            sortType: {},
            date: {
                send_date: {
                    startDate: new Date(),
                    endDate: new Date()
                },
                first_action_date: {
                    startDate: new Date(),
                    endDate: new Date()
                }
            },

            selectedDate: 'send_date',

            totals: {
                total: 0,
                valid: 0,
                invalid: 0,
                ftd: 0,
                summ: 0
            },

            rowspan: ['affiliate'],
            analyticsList: [],
            totalHideKeys: ['total', 'valid', 'invalid', 'ftd', 'summ'],
            display: {
                affiliate_name: true,
                model: true,
                geo: true,
                country: true,
                advertiser: true,
                total: true,
                valid: true,
                invalid: true,
                ftd: true,
                profit: true,
                profit_late: true,
                late: true,
                internal_price: true,
                internal_price_sum: true,
                external_price: true,
                external_price_sum: true
            },

            heads: [
                {
                    name: 'global.Affiliate',
                    value: 'affiliate_name',
                    sortKey: 'affiliate_name',
                    rowspan: 2,
                    display: true,
                    center: true
                },
                {
                    name: 'global.Model',
                    value: 'model',
                    display: true,
                    center: true
                },
                {
                    name: 'global.Geo',
                    value: 'geo',
                    display: true,
                    center: true
                },
                {
                    name: 'global.Country',
                    value: 'country',
                    display: true,
                    center: true
                },
                {
                    name: 'global.Advertiser',
                    value: 'advertiser_name',
                    display: true,
                    center: true
                },
                {
                    name: 'global.Total',
                    value: 'total',
                    display: true,
                    center: true
                },
                {
                    name: 'label.Valid',
                    value: 'valid',
                    display: true,
                    center: true
                },
                {
                    name: 'label.Unvalid',
                    value: 'invalid',
                    display: true,
                    center: true
                },
                {
                    name: 'FTD/%',
                    value: 'ftd',
                    display: true,
                    translate: 'none',
                    center: true
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    display: true,
                    translate: 'none',
                    center: true
                },
                {
                    name: 'Profit late',
                    value: 'profit_late',
                    display: true,
                    translate: 'none',
                    center: true
                },
                {
                    name: 'Late',
                    value: 'late',
                    display: true,
                    translate: 'none',
                    center: true
                },
                {
                    name: 'CRG %',
                    value: 'guarantee_percent',
                    display: true,
                    center: true
                },
                {
                    name: 'label.Internal_price',
                    value: 'internal_price',
                    display: true,
                    center: true
                },
                {
                    name: 'table.Internal_price_summ',
                    value: 'internal_price_sum',
                    display: true,
                    center: true
                },
                {
                    name: 'label.External_price',
                    value: 'external_price',
                    display: true,
                    center: true
                },
                {
                    name: 'table.External_price_summ',
                    value: 'external_price_sum',
                    display: true,
                    center: true
                }
            ],
            keysTransform: {
                advertiser_list: 'advertisers',
                affiliate_list: 'affiliates',
                advertiser_categories: 'advertiser_categories',
                country_list: 'country',
                geo_list: 'geo',
                model_list: 'traffic_model_id',
                external_price_list: 'pay_out',
            }
        }
    },

    components: {
        Table,
        vSelect,
        Trn
    },

    computed: {
        analytics() {
            return this.analyticsList
        },
        userState() {
            return this.$store.getters.userState
        },
    },

    methods: {
        _compare(a1, a2) {
            return a1.length === a2.length && a1.every((v, i) => v === a2[i])
        },

        _sortArr(arr) {
            return arr.sort((a, b) => {
                if (a < b) return -1
            })
        },

        priceMutation(data) {
            return data.map(item => +item)
        },

        createFilterFields() {
            return Object.keys(this.keysTransform).map((key) => {
                const name = this.keysTransform[key] || key
                const obj = {
                    name: `table_filters.${name}`,
                    type: 'select',
                    label: key,
                    field: key,
                    multiple: true,
                    sortKey: ['advertiser_list'].includes(key) ? 'id' : 'name'
                };

                if (key === 'external_price_list') {
                    obj.can = "finance_analytic_access.show_external_price"
                }

                return obj;
            });
        },

        changeDisplay(item) {
            item.display = !item.display
            this.display[item.value] = !this.display[item.value]

            const arr = []
            Object.keys(this.display).map(key => {
                if (this.totalHideKeys.includes(key) && !this.display[key]) arr.push(key)
            })
            const a = this._compare(this._sortArr(arr), this._sortArr(this.totalHideKeys))
            this.isTotal = !a;
        },

        _dateParse(date) {
            return new Date(date).toLocaleString('ru').split(',')[0].split('.').reverse().join('-')
        },

        async refreshFilter() {
            Object.keys(this.date).map(key => Object.keys(this.date[key]).map(k => this.date[key][k] = new Date()))
            Object.keys(this.system.date).map(key => Object.keys(this.system.date[key]).map(k => this.system.date[key][k] = new Date()))

            this.system.selectedDate = 'send_date'
            this.filterSelect = {}

            this.filters = {}
            this.selectedDate = 'send_date'

            await this.get()
        },

        selectDate(date) {
            Object.keys(this.system.date).map(key => {
                this.system.date[key].startDate = new Date()
                this.system.date[key].endDate = new Date()
            })

            this.system.selectedDate = date.direction
            this.system.date[date.direction] = date
        },

        async submitFilter(data) {
            this.filterSelect = data
            this.date[this.system.selectedDate] = this.copy(this.system.date[this.system.selectedDate])

            if (this.pageNum !== 1) {
                this.pageNum = 1
            } else {
                await this.get()
            }
        },

        async sort(data) {
            this.sortType = data
            await this.get()
        },

        async page(page) {
            this.pageNum = page
        },

        async limit(limit) {
            if (this.pageNum !== 1) {
                this.pageNum = 1
            } else {
                if (limit !== this.limitNum) {
                    this.limitNum = limit
                }
            }
        },

        async downloadCSV() {
            try {
                const params = this.getParams('csv')

                const response = await send(this.$url.financeAnalytic.csv, 'GET', {params})
                    .then(res => res.data)

                download(response, `${this._dateParse(new Date())}_${new Date().getTime()}.csv`, 'text/csv')
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        rowsSum(typeSum, model, geo, obj) {
            try {
                let sum = 0

                if (typeSum && typeSum === 'main') {
                    Object.keys(obj).map(key => {
                        Object.keys(obj[key]).map(k => {
                            Object.keys(obj[key][k]).map(l => {
                                sum += obj[key][k][l].length
                            })
                        })
                    })
                }

                if (typeSum && typeSum === 'model') {
                    Object.keys(obj).map(key => {
                        if (key === model) {
                            Object.keys(obj[key]).map(k => {
                                Object.keys(obj[key][k]).map(l => {
                                    sum += obj[key][k][l].length
                                })
                            })
                        }
                    })
                }

                if (typeSum && typeSum === 'geo') {
                    Object.keys(obj).map(key => {
                        if (key === model) {
                            Object.keys(obj[key]).map(k => {
                                if (k === geo) {
                                    Object.keys(obj[key][k]).map(l => {
                                        sum += obj[key][k][l].length
                                    })
                                }
                            })
                        }
                    })
                }

                return sum
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        getParams(type) {
            const params = {
                date_from: this._dateParse(this.date[this.system.selectedDate].startDate),
                date_to: this._dateParse(this.date[this.system.selectedDate].endDate),
                date_field: this.system.selectedDate,
                advertisers: this.filterSelect.advertiser_list,
                advertiser_categories_id: this.filterSelect.advertiser_categories,
                affiliates: this.filterSelect.affiliate_list,
                countries: this.filterSelect.country_list,
                geos: this.filterSelect.geo_list,
                models: this.filterSelect.model_list,
                external_prices: this.filterSelect.external_price_list,
            }

            if (type !== 'csv') {
                Object.keys(this.sortType).map(key => Object.assign(params, {[`order_by[${key}]`]: this.sortType[key]}))
            }

            if (type === 'csv') {
                delete params.page
                delete params.limit
            }

            if (this.is_date === 'send_date') {
                delete params.created_date_from
                delete params.created_date_to
            }

            Object.keys(params).map(key => {
                if (!params[key]) delete params[key]
                if (Array.isArray(params[key]) && !params[key].length) delete params[key]
            })

            return params
        },

        sortData(data) {
            const obj = {}
            const list = Object.keys(data).sort((a, b) => {
                if (a < b) return -1
            })

            list.map(key => {
                for (const name in data) {
                    if (key === name) obj[key] = data[name]
                }
            })

            return obj
        },

        copy(data) {
            return JSON.parse(JSON.stringify(data))
        },

        async get() {
            try {
                this.isLoad = true

                const params = this.getParams()

                const response = await send(this.$url.financeAnalytic.get, 'GET', {params})
                    .then(response => response.data.result)

                this.filterFields = this.createFilterFields()

                this.filters = Object.fromEntries(
                    Object.entries(response.data).filter(([key]) => Object.keys(this.keysTransform).includes(key))
                );

                this.filters.advertiser_list = this.filters.advertiser_list.map(item => ({...item, name:  item.name ? `${item.id} - ${item.name}` : item.id.toString()}))
                this.analyticsList = response.data.items || []

                this.totals = [response.data.total]

                this.totalNum = response.meta.total || 0

                this.isMounted = true
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.isLoad = false
            }
        }
    },

    async mounted() {
        try {
            if (!this.isPermission('finance_analytic_access.show_external_price')) {
                this.heads = this.heads.filter(item => item.value !== 'external_price' && item.value !== 'external_price_sum')
                delete this.display.external_price
                delete this.display.external_price_sum
            }

            if (!this.isPermission('finance_analytic_access.show_internal_price')) {
                this.heads = this.heads.filter(item => item.value !== 'internal_price' && item.value !== 'internal_price_sum')
                delete this.display.internal_price
                delete this.display.internal_price_sum
            }

            if (!this.isPermission('finance_analytic_access.show_late')) {
                this.heads = this.heads.filter(item => item.value !== 'late')
                delete this.display.late
            }

            if (!this.isPermission('finance_analytic_access.show_profit')) {
                this.heads = this.heads.filter(item => item.value !== 'profit')
                delete this.display.profit
            }

            if (!this.isPermission('finance_analytic_access.show_profit_late')) {
                this.heads = this.heads.filter(item => item.value !== 'profit_late')
                delete this.display.profit_late
            }

            await this.get()
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>
<style lang="scss">
.finance_analytics {
    &.isLoad {
        th {
            pointer-events: none;
            color: gray;
        }
    }

    .invalid {
        color: red;
    }

    .vs__dropdown-option--disabled {
        background-color: #f6f6f6;
        color: rgba(0, 0, 0, 0.28) !important;
    }

    .dsTable__content {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    table {
        background: white;
        border-radius: 10px;
    }

    tr, td, th {
        border: 1px solid #cacaca;
    }

    .no_br {
        border: none !important;
    }

    tr {
        vertical-align: middle;

        td {
            div {
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
    }

    .model {
        display: flex;
        flex-direction: column;
    }

    .vs__dropdown-option--selected {
        display: none !important;
    }
}
</style>

